export const BRANDING = {
    APP_NAME: 'Komunidad Climate Scoring',
    LOGO_PATH: '/src/assets/kcs_logo.png', // Vite handles this path in dev, needs handling for prod usually via import
};
